/**
 * DocumentEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionEntity } from "../RegionEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { BugEntity } from "../BugEntity";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
import { DocumentVersionEntity } from "../DocumentVersionEntity";
import { DocumentEntity } from "../DocumentEntity";
declare global {
    interface EntityTypeMap {
        Document: DocumentEntity;
    }
}
export abstract class DocumentGeneratedEntity extends BaseEntity {
    public abstract documentId: string;
    public abstract templateId: string | null;
    public abstract downloadPolicy: string;
    public abstract name: string | null;
    public abstract owningProject: ProjectEntity;
    public abstract project: ProjectEntity | null;
    public abstract region: RegionEntity | null;
    public abstract workPackage: WorkPackageEntity | null;
    public abstract bug: BugEntity | null;
    public abstract calendarModification: CalendarModificationEntity | null;
    public abstract readonly documents: ReadonlyArray<DocumentVersionEntity>;
    public abstract activeVersion: DocumentVersionEntity;
}
